import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { useState } from 'react';

export const ContactSection = ({ className }: { className?: string }) => {
  useLocale();

  const [form, setForm] = useState({
    name: '',
    org: '',
    email: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <section className={className} id="contact">
      <div className="mx-auto max-w-lg px-6">
        {/* Badge */}
        <span className="mb-4 inline-block rounded-full bg-landing-pill-bg px-3 py-1 font-medium text-landing-pill-text text-xs">
          {t('reports.contact')}{' '}
        </span>

        {/* Heading */}
        <h2 className="mb-3 font-bold font-libre-baskerville text-4xl text-landing-heading">
          {t('landing.getInTouch')}{' '}
        </h2>

        {/* Subtitle */}
        <p className="mb-8 text-landing-body text-sm leading-relaxed">
          {t('landing.readyToTransformYourComplianceOperationsReachOutTo')}{' '}
        </p>

        {/* Form */}
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          {/* Full Name */}
          <div>
            <label className="mb-1 block font-medium text-landing-body text-xs" htmlFor="name">
              {t('landing.fullName')}{' '}
            </label>
            <input
              className="w-full rounded-lg border border-landing-card-border bg-landing-card-bg px-4 py-2.5 font-libre-baskerville text-landing-heading text-sm transition placeholder:text-landing-muted focus:outline-none focus:ring-2 focus:ring-primary/30"
              name="name"
              onChange={handleChange}
              placeholder={t('landing.johnDone')}
              type="text"
              value={form.name}
            />
          </div>

          {/* Organization */}
          <div>
            <label className="mb-1 block font-medium text-landing-body text-xs" htmlFor="org">
              {t('landing.organizationNameOptional')}{' '}
            </label>
            <input
              className="w-full rounded-lg border border-landing-card-border bg-landing-card-bg px-4 py-2.5 font-libre-baskerville text-landing-heading text-sm transition placeholder:text-landing-muted focus:outline-none focus:ring-2 focus:ring-primary/30"
              name="org"
              onChange={handleChange}
              placeholder={t('landing.acmeCorporation')}
              type="text"
              value={form.org}
            />
          </div>

          {/* Email */}
          <div>
            <label className="mb-1 block font-medium text-landing-body text-xs" htmlFor="email">
              {t('reports.email')}{' '}
            </label>
            <input
              className="w-full rounded-lg border border-landing-card-border bg-landing-card-bg px-4 py-2.5 font-libre-baskerville text-landing-heading text-sm transition placeholder:text-landing-muted focus:outline-none focus:ring-2 focus:ring-primary/30"
              name="email"
              onChange={handleChange}
              placeholder="john@raven.com"
              type="email"
              value={form.email}
            />
          </div>

          {/* Message */}
          <div>
            <label className="mb-1 block font-medium text-landing-body text-xs" htmlFor="message">
              {t('landing.message')}{' '}
            </label>
            <textarea
              className="w-full resize-none rounded-lg border border-landing-card-border bg-landing-card-bg px-4 py-2.5 font-libre-baskerville text-landing-heading text-sm transition placeholder:text-landing-muted focus:outline-none focus:ring-2 focus:ring-primary/30"
              name="message"
              onChange={handleChange}
              placeholder={t('landing.tellUsHowCanWeHelpYou')}
              rows={4}
              value={form.message}
            />
          </div>

          {/* Submit */}
          <div>
            <button
              className="rounded-md bg-primary px-8 py-2.5 font-semibold text-primary-foreground text-sm transition hover:opacity-90"
              type="submit"
            >
              {t('landing.submit')}{' '}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};
